import { Form, Formik } from "formik";
import * as Yup from "yup";
import React from "react";
import Input from "../Inputs/Input";

import "./DangerZoneFormDelete.scss";
import { useDispatch } from "react-redux";

const DangerZoneFormDelete = ({ element, action, remove }) => {
  const { _id, name } = element[0];

  const dispatch = useDispatch();

  const initialValues = {
    nameElement: name,
    name: "",
  };

  const handleFormikSubmit = (values) => {
    if (values.name === values.nameElement) {
      dispatch(action(_id));
      dispatch(remove());
    }
  };

  const elementSchema = Yup.object().shape({
    name: Yup.string()
      .oneOf([Yup.ref("nameElement"), null], "Does not match!")
      .required("Name is Required"),
  });
  return (
    <div className="form-modal__delete">
      <div className="form-modal__container">
        <h2 className="title-gray-black-18 form-modal__title">
          Are you absolutely sure?
        </h2>
        <p className="text-20-grey form-modal__paragraph">
          This action cannot be undone. This will permanently delete the{" "}
          <span className="text-20-grey--bold">{name}</span> element.
        </p>
        <p className="text-20-grey form-modal__paragraph">
          Please type <span className="text-20-grey--bold">{name}</span> to
          confirm.
        </p>

        <div>
          <Formik
            initialValues={initialValues}
            onSubmit={handleFormikSubmit}
            validationSchema={elementSchema}
          >
            <Form>
              <Input name="name" isModal={true} />
              <button
                className={`btn-danger`}
                type="submit"
                // disabled={disable}
              >
                I understand the consequences, delete this element
              </button>
            </Form>
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default DangerZoneFormDelete;
